export default "__VITE_ASSET__DE$yRnU$__"